import React, { useEffect, useState } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import webPayLogo from '../../assets/img/webpay-logo.svg'
import { getExperienceById } from '../../services/FirebaseServices/experienceServices'
import { getAgencyById } from '../../services/FirebaseServices/agencyServices'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { getDateTime, formatDateToDB } from '../../utils/helpers'
import axios from 'axios'

//REDUX
import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectHotelHour,
  makeSelectPartialPrice,
  makeSelectService,
  makeSelectSelectedAddons,
  makeSelectAddonsPersonsPrice,
  makeSelectCode,
  makeSelectGiftCard,
} from '../../redux/ducks/reservationDetails'

import {
  makeSelectName,
  makeSelectLastName,
  makeSelectPhone,
  makeSelectEmail,
  makeSelectGiftedName,
  makeSelectGiftedLastName,
  makeSelectGiftedPhone,
  makeSelectGiftedEmail,
} from '../../redux/ducks/reservationInfo'

import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import { createReservation } from '../../services/FirebaseServices/reservationServices'

import { statePayments, stateReservation } from '../../utils/enums'

import { makeSelectTermsAndConditions } from '../../redux/ducks/verifyReservation'

import {
  makeSelectTotalOrderPrice,
  makeSelectOrderProducts,
  makeSelectDeliveryAddress,
  makeSelectOrderIndications,
  makeSelectDispatchMethod,
} from '../../redux/ducks/restaurantMenu'

import { LazyLoadImage } from 'react-lazy-load-image-component'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectGuestAmount,
    makeSelectName,
    makeSelectLastName,
    makeSelectPhone,
    makeSelectEmail,
    makeSelectTermsAndConditions,
    makeSelectSingleExperience,
    makeSelectSingleDate,
    makeSelectTime,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectHotelHour,
    makeSelectAgency,
    makeSelectPartialPrice,
    makeSelectTotalOrderPrice,
    makeSelectOrderProducts,
    makeSelectDeliveryAddress,
    makeSelectOrderIndications,
    makeSelectDispatchMethod,
    makeSelectService,
    makeSelectSelectedAddons,
    makeSelectAddonsPersonsPrice,
    makeSelectCode,
    makeSelectGiftedName,
    makeSelectGiftedLastName,
    makeSelectGiftedPhone,
    makeSelectGiftedEmail,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  ) => ({
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  }),
)

const WebPayModule = ({
  agencyId,
  experienceId,
  isDiscountApplied,
  detailDiscount,
  isError,
  isExpirationCode,
  isErrorDay,
  validateTerms,
}) => {
  const {
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  } = useSelector(stateSelector)

  const [isLoadingPayment, setIsLoadingPayment] = useState(false)

  const formatReservationDetails = (orderId = '', transaction_ID = '') => {
    if (singleExperience.category === 'HOTEL') {
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day: formatDateToDB(startDate),
        dayFrom: formatDateToDB(startDate),
        dayTo: formatDateToDB(endDate),
        email: email,
        experience: singleExperience.key,
        detailExperience: {
          id: singleExperience.key,
          name: singleExperience.name,
        },
        detailAgency: {
          id: agency.key,
          name: agency.name,
        },
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: hotelHour,
        lastName: lastName,
        name: name,
        paymentStatus: statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status: stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: 0,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
              isGiftCard: giftCard,
              isReScheduled: false,
              giftedName: giftedName,
              giftedLastName: giftedLastName,
              giftedPhone: giftedPhone,
              giftedEmail: giftedEmail,
            }
          : { isGiftCard: giftCard },
      }
    } else {
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day: formatDateToDB(singleDate),
        email: email,
        experience: singleExperience.key,
        detailExperience: {
          id: singleExperience.key,
          name: singleExperience.name,
        },
        detailAgency: {
          id: agency.key,
          name: agency.name,
        },
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: time,
        lastName: lastName,
        name: name,
        paymentStatus: statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status: stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: 0,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
              isGiftCard: giftCard,
              isReScheduled: false,
              giftedName: giftedName,
              giftedLastName: giftedLastName,
              giftedPhone: giftedPhone,
              giftedEmail: giftedEmail,
            }
          : { isGiftCard: giftCard },
      }
    }
  }

  const handlePayment = async () => {
    const isDiscount = isDiscountApplied
    const { discount } = detailDiscount
    let amount = 0
    const total = parseInt(totalPrice + addonsPersonsPrice)

    if (isDiscount) {
      amount = total - (total * discount) / 100
    } else {
      amount = total
    }

    setIsLoadingPayment(true)
    const reservationDetails = formatReservationDetails()
    const reservationId = await createReservation(
      agency.key,
      singleExperience.key,
      reservationDetails,
    )

    const dataWebPay = {
      buy_order: reservationId,
      session_id: `${agency.key}/${singleExperience.key}`,
      amount,
      return_url: `${process.env.REACT_APP_WEBPAY_API}/commit`,
    }

    await axios
      .post(`${process.env.REACT_APP_WEBPAY_API}/create`, dataWebPay)
      .then((response) => {
        window.location = `${response.data.url}?token_ws=${response.data.token}`
      })
  }

  return (
    <>
      <Button
        disabled={isError || isExpirationCode || isErrorDay || !validateTerms()}
        variant="contained"
        style={{ width: '100%', backgroundColor: '#fff', height: '50px' }}
        onClick={() => handlePayment()}
      >
        {isLoadingPayment ? (
          <CircularProgress size={20} />
        ) : (
          <>
            Pagar con{' '}
            <LazyLoadImage
              width="auto"
              height="auto"
              alt={'webPayLogo'}
              src={webPayLogo}
              style={{ width: '80px', marginLeft: '10px' }}
            />
          </>
        )}
      </Button>
    </>
  )
}

export default WebPayModule
